import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetUser(userId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/user" + (userId ? "/" + userId : ""),
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetManagers() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/user/managers",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetAllUsers() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/user/all",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetMentionableServiceUsers() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/user/service/mentionable",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestCreateUser(userData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/user",
        data: userData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateUser(userId, userData) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId,
        data: userData,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUploadUserAvatar(formData) {
    return axios.request({
        method: "post",
        url: getApiUrl() + "/user/me/avatar",
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
    });
}

export function requestRemoveUserAvatar(userId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/user/" + userId + "/avatar",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestDeleteUser(userId) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/user/" + userId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestRestoreUser(userId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId + "/restore",
        withCredentials: true,
        crossorigin: true
    });
}
export function requestActivateUser(userId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId + "/activate",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestDeactivateUser(userId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId + "/deactivate",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestGetUserDeactivationImpact(userId) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/user/" + userId + "/deactivation-impact",
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateUserPassword(userId, password, currentPassword, mustChangePassword) {
    const data = { password };
    if (currentPassword) {
        data.currentPassword = currentPassword;
    }
    if (mustChangePassword) {
        data.mustChangePassword = true;
    }
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId + "/password",
        data,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestAddUserAccounts(userId, accounts) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId + "/accounts",
        data: { accounts },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestRemoveUserAccounts(userId, accounts) {
    return axios.request({
        method: "delete",
        url: getApiUrl() + "/user/" + userId + "/accounts",
        data: { accounts },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateUserAccountRole(userId, accountId, newRole) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId + "/account/" + accountId + "/role",
        data: { newRole },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateUserRole(userId, roleId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId + "/role",
        data: { role: roleId },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdateUserEmail(userId, email) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/" + userId + "/email",
        data: { email },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUserAccessFlags(params) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/user/access-flags",
        params,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestSetUserApiAccess(userId, apiAccess) {
    return axios.request({
        method: "patch",
        url: getApiUrl() + "/user/" + userId + "/api-access",
        data: { apiAccess },
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUserAssignments(userId = null) {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/user/assignments" + (userId ? "/" + userId : ""),
        withCredentials: true,
        crossorigin: true
    });
}

export function requestToggleStarredItem(objectId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/star/" + objectId,
        withCredentials: true,
        crossorigin: true
    });
}

export function requestUpdatePinnedAccounts(accountId) {
    return axios.request({
        method: "put",
        url: getApiUrl() + "/user/pin-account/" + accountId,
        withCredentials: true,
        crossorigin: true
    });
}